/**
 * App light theme — clinical HealthDesk palette (Federo headings, blue primary).
 * Brand colors/fonts: @asi/design-tokens lightTheme.
 */

import { createTheme } from '@mui/material/styles';
import { lightTheme } from '@asi/design-tokens';
import { muiTheme } from 'config/theme';

export const FUSION_MSI_AUDIENCE_ACCENTS_LIGHT = {
  patient: { main: '#2E8B7F', soft: '#5AA99E', dim: 'rgba(46,139,127,0.10)' },
  clinician: { main: '#7B52B0', soft: '#9C7BC9', dim: 'rgba(123,82,176,0.10)' },
  facility: { main: '#A9772E', soft: '#C99B54', dim: 'rgba(169,119,46,0.10)' },
  fde: { main: '#C05A34', soft: '#D9825F', dim: 'rgba(192,90,52,0.10)' },
};

/** SavoirCare board accents — lounge chip + location pills (warning/error/info/success soft tones). */
export const FUSION_MSI_BOARD_ACCENTS_LIGHT = {
  lounge: { bg: '#FAEEDA', color: '#854F0B', border: '#EF9F27' },
  location: {
    lounge: { bg: '#FEF3C7', color: '#92400E', border: '#EF9F27' },
    trauma: { bg: '#FCEBEB', color: '#A32D2D', border: '#A32D2D' },
    procedure: { bg: '#E6F1FB', color: '#0C447C', border: '#0C447C' },
    default: { bg: '#EAF3DE', color: '#27500A', border: '#27500A' },
  },
};

export const appLightTheme = createTheme({
  ...muiTheme,
  palette: {
    ...muiTheme.palette,
    mode: 'light',
    audience: FUSION_MSI_AUDIENCE_ACCENTS_LIGHT,
    board: FUSION_MSI_BOARD_ACCENTS_LIGHT,
  },
  typography: {
    ...muiTheme.typography,
    fontFamily: lightTheme.fonts.body,
    h1: { fontFamily: lightTheme.fonts.display },
    h2: { fontFamily: lightTheme.fonts.display },
    h3: { fontFamily: lightTheme.fonts.display },
    h4: { fontFamily: lightTheme.fonts.display },
    h5: { fontFamily: lightTheme.fonts.display },
    h6: { fontFamily: lightTheme.fonts.display },
  },
});

export default appLightTheme;

/** @deprecated Use appLightTheme */
export const decisionPointLightTheme = appLightTheme;
